import React, { useState } from "react";
import { Button, Modal, Flex, Typography } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import GenericTable from "./GenericTable";
import { useInvoiceColumns } from "../components/InvoiceColumns";
import GeneratePdfForm from "./GeneratePdfForm"; // Import your form

const { Title } = Typography;

export default function InvoicesTable() {
  const getInvoiceColumns = useInvoiceColumns();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const showModal = () => setIsModalOpen(true);
  const handleCancel = () => setIsModalOpen(false);

  return (
    <div style={{ padding: "20px" }}>
      {/* Header Section */}
      <Flex justify="end" align="center" style={{ marginBottom: 16 }}>
        <Button 
          type="primary" 
          icon={<PlusOutlined />} 
          onClick={showModal}
          size="large"
        >
          Generate Invoice
        </Button>
      </Flex>

      {/* Table Section */}
      <GenericTable
        apiPath="/crm/invoice"
        columns={getInvoiceColumns}
      />

      {/* Pop-up Modal containing the Form */}
      <Modal
        title={null} // We use the internal Card title instead
        open={isModalOpen}
        onCancel={handleCancel}
        footer={null} // Hide default OK/Cancel buttons
        width={750}
        destroyOnClose // Resets form state when closed
      >
        <GeneratePdfForm closeParentModal={handleCancel} />
      </Modal>
    </div>
  );
}